import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import classNames from 'classnames';

import styles from './styles/ListView.scss';

const ListHead = ({ showDealerBranding, showProjects }) => {
    const colClasses = classNames(styles.col4, {
        [styles.col5]: showProjects,
        [styles.sellerCol]: showDealerBranding,
    });
    const titleClasses = classNames(styles.colTitle, {
        [styles.titleHeader]: !showDealerBranding,
    });
    return (
        <div className={styles.header}>
            {showDealerBranding && (
                <div className={`${styles.colSellerName} ${styles.titleHeader}`}>
                    <FormattedMessage
                        id="portfolio.listView.col_seller"
                        defaultMessage="Offered By"
                    />
                </div>
            )}
            <div className={titleClasses}>
                <FormattedMessage id="portfolio.listView.col_title" defaultMessage="Item Title" />
            </div>
            <div className={styles.colImage}>
                <FormattedMessage id="portfolio.listView.col_image" defaultMessage="Image" />
            </div>
            <div className={colClasses}>
                <FormattedMessage id="portfolio.listView.col_price" defaultMessage="Price" />
            </div>
            <div className={colClasses}>
                <FormattedMessage id="portfolio.listView.col_shipping" defaultMessage="Shipping" />
            </div>
            <div className={colClasses}>
                <FormattedMessage id="portfolio.listView.col_status" defaultMessage="Item Status" />
            </div>
            {showProjects && (
                <div className={colClasses}>
                    <FormattedMessage
                        id="portfolio.listView.col_project"
                        defaultMessage="Project"
                    />
                </div>
            )}
            <div className={colClasses}>
                <FormattedMessage id="portfolio.listView.col_note" defaultMessage="Note" />
            </div>
        </div>
    );
};

ListHead.propTypes = {
    showDealerBranding: PropTypes.bool,
    showProjects: PropTypes.bool,
};

export default ListHead;
